module.exports = __webpack_public_path__ + "img/planetchicken.9b23bb20.png";